import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row, Button, Form, Label, Input } from 'reactstrap';
import Select from 'react-select'; // React Select for dropdowns
import { addWorkOrder, getSebelUsers, getSolutions, getTeams, getWorkOrders, getWorkOrderStates } from 'store/actions'; // Actions for fetching and adding work orders
import CreateWorkOrder from './CreateWorkOrder'; // Modal or form to create a work order
import WorkOrderTable from './WorkOrderTable'; // Table to display work orders
import Breadcrumb from 'components/Common/Breadcrumb2'; // Breadcrumb component
import { convertDateFormat, convertToDateOnly2 } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import { showError } from 'helpers/notification_helper';

const WorkOrderList = () => {
    const today = new Date().toISOString().split('T')[0];
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const [isOpen, setIsOpen] = useState(false); // State to control the modal visibility
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [createdAt,setCreatedAt] = useState();
    const [createdDate, setCreatedDate] = useState(null);
    const [selectedSebelUserId,setSelectedSebelUserId] = useState();
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(status ? { value: 'WorkOrder Pending', label: 'Work Order Pending' } : null);
    const [selectedSolution, setSelectedSolution] = useState(null)
    const [sebeleIdSolution, setsebeleIdSolution] = useState(null);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sorting, setSorting] = useState([{ id: 'workOrderId', desc: true }]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchVal, setSearchVal] = useState("");
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    const location = useLocation();

    const cookieEndDate = Cookies.get('endDate');
    const cookieStartDate = Cookies.get('startDate');
    const cookieSelectedTeam = Cookies.get('selectedTeam') ? JSON.parse(Cookies.get('selectedTeam')) : "";
    const cookieSelectedStatus = Cookies.get('selectedStatus') ? JSON.parse(Cookies.get('selectedStatus')) : "";
    const cookiePageUrl = Cookies.get('pageUrl');
    const cookieSelectedSolution = Cookies.get('selectedSolution');
    const cookieCreatedAt = Cookies.get('createdAt');
    const cookieSebelUserId = Cookies.get('sebelUserId');
    const pageUrl = location.pathname

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Selectors to access Redux state
    const workOrders = useSelector((state) => state.WorkOrder.workorders);
    const workOrderStates = useSelector((state) => state.WorkOrder.workOrderStates);
    const solutions = useSelector(state => state.Solution.solutions);
    const teams = useSelector((state) => state?.Team?.teams)
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const loading = useSelector((state) => state.WorkOrder.loading);
    const statesLoading = useSelector((state) => state.WorkOrder.statesLoading);
    const teamsLoading = useSelector((state) => state.Team.loading);
    const solutionsLoading = useSelector((state) => state.Solution.loading);
    const sebelUsersLoading = useSelector((state) => state.SebelUser.loading);
    const totalCount = useSelector((state) => state.WorkOrder.totalCount);
    const error = useSelector((state) => state.WorkOrder.error);

    // Fetch permissions from localStorage
    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Sample team and status options (replace with actual data if available)
    const teamOptions = teams?.Data?.map(item => ({ label: item?.teamName, value: item?.teamId }))

    const statusOptions = workOrderStates?.Data?.map(item => ({
        value: item?.stateName,
        label: item?.stateName,
    })) || [];
    const solutionOptions = [
        { value: 'iot', label: 'IOT' },
        { value: '5g', label: '5G' },
    ];
    const sebeleIdOptions = [];

    useEffect(() => {
        if (loading && cookieEndDate || cookieStartDate || cookieSelectedTeam || cookieSelectedStatus || cookieCreatedAt || cookieSelectedSolution || cookieSebelUserId) return;
        dispatch(getTeams(true));
        dispatch(getSolutions());
        dispatch(getSebelUsers())
        dispatch(getWorkOrderStates())
        
        const sortColId = sorting[0]?.id || 'workOrderNumber';
        const sortCol = getColumnIndex(sortColId);
        const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';
        
        dispatch(getWorkOrders(
            id, 
            selectedStatus?.value, 
            startDate, 
            endDate, 
            selectedTeam?.value,
            selectedSolution,
            convertToDateOnly2(createdAt),
            String(selectedSebelUserId),
            pageSize,
            pageIndex * pageSize,
            sortCol,
            sortDir,
            searchTerm
        ));
    }, [dispatch, pageIndex, pageSize, sorting, searchTerm]);

    useEffect(() => {
        if (cookieEndDate && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setEndDate(cookieEndDate);
        }
        if (cookieStartDate && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setStartDate(cookieStartDate);
        }
        if (cookieSelectedTeam && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedTeam(cookieSelectedTeam);
        }
        if (cookieSelectedStatus && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedStatus(cookieSelectedStatus);
        }
        if (cookieSelectedSolution && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedSolution(cookieSelectedSolution);
        }
        if (cookieCreatedAt && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setCreatedAt(cookieCreatedAt);
        }
        if (cookieSebelUserId && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedSebelUserId(cookieSebelUserId);
        }
        if ((cookieEndDate || cookieStartDate || cookieSelectedTeam || cookieSelectedStatus || cookieCreatedAt || cookieSelectedSolution || cookieSebelUserId) && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            dispatch(getWorkOrders(id, cookieSelectedStatus?.value, cookieStartDate, cookieEndDate, cookieSelectedTeam?.value,cookieSelectedSolution,convertToDateOnly2(cookieCreatedAt),String(cookieSebelUserId)));

        }
        Cookies.remove('endDate');
        Cookies.remove('startDate');
        Cookies.remove('selectedTeam');
        Cookies.remove('selectedStatus');
        Cookies.remove('pageUrl');
        Cookies.remove('selectedSolution');
        Cookies.remove('createdAt');
        Cookies.remove('sebelUserId');
    }, [location]);
    
    useEffect(() => {
        localStorage.setItem('endDate', endDate);
        localStorage.setItem('startDate', startDate);
        localStorage.setItem('selectedTeam', JSON.stringify(selectedTeam));
        localStorage.setItem('selectedStatus', JSON.stringify(selectedStatus));
        localStorage.setItem('pageUrl', location?.pathname)
        localStorage.setItem('selectedSolution',selectedSolution)
        localStorage.setItem('createdAt',createdAt)
        localStorage.setItem('sebelUserId',selectedSebelUserId)
    }, [endDate, startDate, selectedStatus, selectedTeam, location,selectedSolution,createdAt,selectedSebelUserId])


    const getColumnIndex = (accessorKey) => {
        const mapping = {
            'workOrderNumber': 0,
            'remedyNumber': 1,
            'teamName': 2,
            'customerNameEng': 3,
            'contactNumber1': 4,
            'createdBy': 5,
            'areaName': 6,
            'contractId': 7,
            'solution': 8,
            'createdAt': 9,
            'scheduledStartDateTime': 10,
            'scheduledEndDateTime': 11,
            'workOrderStatus': 12
        };
        return mapping[accessorKey] !== undefined ? mapping[accessorKey] : 0;
    };

    const handleSearch = () => {
        if (new Date(startDate) > new Date(endDate)) {
            showError("End datetime must be after start datetime")
        } else {
            setPageIndex(0); // Reset to first page on new filter search
            setSearchTerm(searchVal);
            
            const sortColId = sorting[0]?.id || 'workOrderNumber';
            const sortCol = getColumnIndex(sortColId);
            const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';
            
            dispatch(getWorkOrders(
                id, 
                selectedStatus?.value, 
                startDate, 
                endDate, 
                selectedTeam?.value,
                selectedSolution,
                convertToDateOnly2(createdAt),
                String(selectedSebelUserId),
                pageSize,
                0, // start at 0
                sortCol,
                sortDir,
                searchVal
            ));
        }
    };

    return (
        <>
            <div className='page-content container-fluid'>
                <div className='d-flex justify-content-between align-items-center mx-3'>
                    <Breadcrumb
                        title="Work Orders"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Work Orders", link: '#' }
                        ]}
                    />
                    {permissions2?.map(item => item?.permissionName)?.includes("Add Work Orders") && (
                        <Button
                            className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center'
                            onClick={() => navigate(`/createWorkOrder`)}
                        >
                            <i className='ti-plus'></i> Add New
                        </Button>
                    )}
                </div>

                {/* Filters Section */}
                <div className='filters-section mx-3'>
                    <Form className="my-3">
                        <Row className="g-3">
                            {/* Start Date */}
                            <Col xs={6} md={3}>
                                <Label for="startDate">Start Date</Label>
                                <Input
                                    type="date"
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* End Date */}
                            <Col xs={6} md={3}>
                                <Label for="endDate">End Date</Label>
                                <Input
                                    type="date"
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>
                            {/* Created Date */}
                            <Col xs={6} md={3}>
                                <Label for="createdAt">Created Date</Label>
                                <Input
                                    type="date"
                                    id="createdAt"
                                    value={createdAt}
                                    onChange={(e) => setCreatedAt(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* Team Selector */}
                            <Col xs={6} md={3}>
                                <Label for="team">Team</Label>
                                <Select
                                    id="team"
                                    options={teamOptions}
                                    value={selectedTeam}
                                    isLoading={teamsLoading}
                                    onChange={setSelectedTeam}
                                    placeholder="Select Team"
                                    isClearable={true}
                                />
                            </Col>

                            {/* Work Order Status Selector */}
                            <Col xs={6} md={3}>
                                <Label for="status" className='mt-1'>Status</Label>
                                <Select
                                    id="status"
                                    options={statusOptions}
                                    value={selectedStatus}
                                    isLoading={statesLoading}
                                    onChange={setSelectedStatus}
                                    placeholder="Select Status"
                                    isClearable={true}
                                />
                            </Col>

                            {/* Work Order Solution Selector */}
                            <Col xs={6} md={3}>
                                <Label for="solution" className='mt-1'>Solution</Label> 
                                <Select
                                    id="solution"
                                    options={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))}
                                    value={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))?.find(option => option?.value == selectedSolution)||""}
                                    isLoading={solutionsLoading}
                                    onChange={option => { setSelectedSolution(option?.value);}}
                                    placeholder="Select Solution"
                                    isClearable={true}
                                />
                            </Col>

                            {/* Work Order Sebele User ID */}
                            <Col xs={6} md={3}>
                                <Label for="sebelUserId" className='mt-1'>Siebel User ID</Label>
                                <Select
                                    id="sebelUserId"
                                    options={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))}
                                    value={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))?.find(option=>option?.value == selectedSebelUserId || "")}
                                    isLoading={sebelUsersLoading}
                                    onChange={option=>{setSelectedSebelUserId(option?.value)}}
                                    placeholder="Select Siebel User ID"
                                    isClearable={true}
                                />
                            </Col>

                             {/* Global Search Input */}
                            <Col xs={6} md={3}>
                                <Label for="searchField" className='mt-1'>Search</Label>
                                <Input
                                    type="text"
                                    id="searchField"
                                    placeholder="Search..."
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            <Col xs={6} md={3} className='d-flex justify-start align-center'>
                                <Button color="primary mt-auto" style={{ marginBottom: '2px' }} onClick={handleSearch}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* Work Orders Table */}
                <WorkOrderTable 
                    loading={loading} 
                    List={workOrders?.Data} 
                    totalCount={totalCount}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    sorting={sorting}
                    onPaginationChange={(state) => {
                        setPageIndex(state.pageIndex);
                        setPageSize(state.pageSize);
                    }}
                    onSortingChange={setSorting}
                    onGlobalFilterChange={setSearchTerm}
                />
            </div>
        </>
    );
};

export default WorkOrderList;
